import React from "react";

import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives";
import { token } from "@atlaskit/tokens";

import { ProductKey } from "@/components/signup/utils";
import { wacToken } from "@/libraries/design/foundations";

import { messages } from "./messages";

export interface LegalNoticeProps {
    onClick?: (e: React.MouseEvent) => void;
    productName: string;
    productKey?: ProductKey;
}

const termsTextStyleJsm = css({
    fontFamily: wacToken("font.charlie.text"),
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "16px",
    color: token("color.text.subtlest"),
    margin: 0,
    [media.above.lg]: {
        fontSize: "14px",
        lineHeight: "16px"
    }
});

const termsLinkStyle = css({
    "color": token("color.link"),
    "textDecoration": "none",
    "&:hover": {
        textDecoration: "underline"
    }
});

export const TemplateLegalNotice: React.FC<LegalNoticeProps> = ({
    onClick,
    productName,
    productKey
}) => {
    const isJPD = productKey === ProductKey.JIRA_PRODUCT_DISCOVERY;

    const legalNoticeMessage = isJPD
        ? messages.legalNoticeJPD
        : messages.legalNotice;

    const additionalInfoMessage = isJPD
        ? messages.additionalInfoJPD
        : messages.additionalInfo;

    const customerAgreementLink = (
        <a
            href="https://www.atlassian.com/legal/customer-agreement"
            target="_blank"
            rel="noopener noreferrer"
            css={termsLinkStyle}
            onClick={onClick}
        >
            <FormattedMessage {...messages.customerAgreementLinkText} />
        </a>
    );

    const privacyPolicyLink = (
        <a
            href="https://www.atlassian.com/legal/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            css={termsLinkStyle}
            onClick={onClick}
        >
            <FormattedMessage {...messages.privacyPolicyLinkText} />
        </a>
    );

    return (
        <p css={termsTextStyleJsm}>
            <FormattedMessage
                {...legalNoticeMessage}
                values={{
                    customerAgreementLink,
                    privacyPolicyLink
                }}
            />{" "}
            <FormattedMessage
                {...additionalInfoMessage}
                values={{ productName }}
            />
        </p>
    );
};
